var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 38,
    width: 89,
    height: 73,
    rx: 8,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 59H56.5C54.8431 59 53.5 60.3431 53.5 62C53.5 63.6569 54.8431 65 56.5 65H82.5C84.1569 65 85.5 63.6569 85.5 62C85.5 60.3431 84.1569 59 82.5 59Z",
    fill: "#AAA8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 85H56.5C54.8431 85 53.5 86.3431 53.5 88C53.5 89.6569 54.8431 91 56.5 91H95C96.6569 91 98 89.6569 98 88C98 86.3431 96.6569 85 95 85Z",
    fill: "#AAA8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 72H56.5C54.8431 72 53.5 73.3431 53.5 75C53.5 76.6569 54.8431 78 56.5 78H100.5C102.157 78 103.5 76.6569 103.5 75C103.5 73.3431 102.157 72 100.5 72Z",
    fill: "#C7C6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.487 120.938C104.034 120.938 106.508 120.086 108.514 118.517L114.823 124.826L116.852 122.797L110.541 116.486C112.127 114.436 112.971 111.909 112.937 109.318C112.903 106.726 111.992 104.223 110.353 102.215C108.714 100.208 106.443 98.8147 103.911 98.2629C101.378 97.7112 98.7339 98.0334 96.4082 99.177C94.0825 100.321 92.2126 102.218 91.1034 104.561C89.9943 106.903 89.7111 109.552 90.3002 112.076C90.8892 114.6 92.3157 116.85 94.3472 118.459C96.3787 120.068 98.8954 120.942 101.487 120.938ZM101.487 100.844C103.191 100.844 104.857 101.349 106.275 102.296C107.692 103.243 108.796 104.589 109.448 106.163C110.101 107.738 110.271 109.47 109.939 111.142C109.606 112.814 108.786 114.349 107.58 115.554C106.375 116.759 104.84 117.58 103.168 117.913C101.497 118.245 99.764 118.074 98.1894 117.422C96.6148 116.77 95.269 115.666 94.3221 114.248C93.3752 112.831 92.8698 111.165 92.8698 109.461C92.8698 107.175 93.7777 104.984 95.3938 103.368C97.0098 101.752 99.2016 100.844 101.487 100.844Z",
    fill: "#5551FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 28.5,
    y: 35,
    width: 101,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 75.5,
    y1: 0.00000166893,
    x2: 131.5,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEAEA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.e77680dfc477ef4e911f5642c335761e.svg";
export { ForwardRef as ReactComponent };